import { axiosInventoryInstance } from '@/config/apiConfig';
import { API_URL_CONFIG } from '@/config/urlConfig/apiUrlConfig';
import { MAGIC_COOKIES } from '@/pages/StandAlone/constants';
import { getCookie } from '@/standalone';
import { AxiosResponse } from 'axios';

export interface IApprovedProductsParams {
  page?: number;
  limit?: number;
  includeInactive?: boolean;
  // Search parameters
  barcode?: string;
  productIdIdentifier?: string;
  name?: string;
  // Sorting parameters
  orderBy?: string;
  order?: string;
}

export interface IApprovedProduct {
  smartCoolerProductId: string;
  productName: string;
  shortProductName?: string;
  productImage?: string;
  barcodes: string[];
}

export interface IApprovedProductsResponse {
  success: boolean;
  data: IApprovedProduct[];
  pagination?: {
    totalRecords: number;
    currentPage: number;
    totalPages: number;
  };
  message?: string;
}

// GET Approved Products for standalone mode (uses cookies sid and sig for auth)
export const fetchApprovedProducts = (
  params?: IApprovedProductsParams,
): Promise<AxiosResponse<IApprovedProductsResponse>> => {
  const {
    page = 1,
    limit = 100,
    includeInactive = false,
    barcode,
    productIdIdentifier,
    name,
    orderBy,
    order,
  } = params || {};

  return axiosInventoryInstance({
    url: API_URL_CONFIG.MAGIC_URL.SMARTCOOLER_APPROVED_PRODUCTS,
    method: 'GET',
    headers: {
      'x-gw-magic-sid': getCookie(MAGIC_COOKIES.SID) || '',
      'x-gw-magic-sig': getCookie(MAGIC_COOKIES.SIG) || '',
    },
    params: {
      page,
      limit,
      includeInactive,
      ...(barcode && { barcode }),
      ...(productIdIdentifier && { productIdIdentifier }),
      ...(name && { name }),
      ...(orderBy && { orderBy }),
      ...(order && { order }),
    },
  });
};
